import { useCallback, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import {
  getOrchestratorNid,
  getSelectedResponse,
  getEditorStatus,
  getEditorTaskType,
  setEditorPayloadTask,
} from '@domains/orchestrator-pricing-committee/store/slices/domainOrchestratorPricingCommittee.slice';
import { useSelectedWorkflowStep } from '@domains/orchestrator-pricing-committee/hooks/useSelectedWorkflowStep';
import { useJsonEditor } from '@domains/orchestrator-pricing-committee/components/ModalOrchestratorSupportTool/hooks/useJsonEditor';

export const JSONEditorTask = () => {
  const { step } = useSelectedWorkflowStep();
  const nid = useSelector(getOrchestratorNid);
  const country = useSelector(getCountry);
  const selectedResponse = useSelector(getSelectedResponse);
  const editorStatus = useSelector(getEditorStatus);
  const taskType = useSelector(getEditorTaskType);
  const dispatch = useDispatch();

  const handleChange = useCallback(
    (updated: Record<string, unknown>) => {
      dispatch(setEditorPayloadTask(updated));
    },
    [dispatch],
  );

  const { containerRef, setExternalJson } = useJsonEditor({ onChange: handleChange });

  useEffect(() => {
    if (!step) return;

    const agent =
      (step.responses?.[selectedResponse]?.detail as { owner_process?: string })
        ?.owner_process ?? '';

    const payload = {
      agent,
      nid,
      country: country ?? '',
      status: editorStatus.toLowerCase(),
      task_type: taskType,
    } as Record<string, unknown>;

    setExternalJson(payload);
    dispatch(setEditorPayloadTask(payload));
  }, [
    nid,
    country,
    step,
    selectedResponse,
    taskType,
    editorStatus,
    setExternalJson,
    dispatch,
  ]);

  if (!step) return null;

  return (
    <div data-testid="json-editor-task-container">
      <div ref={containerRef} style={{ height: '400px' }} />
    </div>
  );
};
